import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { formatUrl, formatImageUrlByDevice, shorten } from "../../helpers/Helper";
import { useAppContext } from "@components/Provider";
import { apiRequestWithRetry } from "src/services/ClientSideAPIService";
import NextImage from "@components/Image/NextImage";

import styles from "./HomePageStories.module.css";
import "./HomePageStories.css";
import Deals from "@components/Deals/Deals";

const SheKnowsAd = dynamic(() => import("../Ads/SheKnowsAd"), { ssr: false });
const GoogleAdSense = dynamic(() => import("../Ads/GoogleAdSense"));

const getColorsForMobile = (props, key, type) => {
  let color = "";
  if (props && props?.type === "trendingStories") {
    color = "#fff";
  }
  if (props.isMobile && props?.type == "recentStories") {
    if (key % 2 !== 0) {
      color = "#fff";
    } else {
      color = "#000";
    }
  } else if (type == "promoted" || type == "authorby") {
    color = "#000";
  }
  return color;
};

const renderAuthor = (post, props, key) => {
  let byline = "";
  if (post.byline) {
    byline = post.byline;
  }
  if (post.Byline) {
    byline = post.Byline;
  }
  if (byline && byline.length > 0 && !post.topStoriesChecked) {
    let displayNames = byline.map((author, i) => {
      let authorName = author.display_name || author.Display_Name;
      let separator = "";
      if (i > 0 && i === byline.length - 1) {
        separator = <span>&nbsp;&&nbsp;</span>;
      } else {
        if (i) {
          separator = ", ";
        }
      }
      return (
        <span key={i}>
          {separator}
          <a href={"/author/" + encodeURIComponent(authorName)} key={i}>
            <span className={styles["authorName"]}>{authorName}</span>
          </a>
        </span>
      );
    });
    return (
      <span
        style={{
          "--author_by_font_weight": `${props?.type == "trendingStories" ? "normal" : "bold"}`,
          "--author_by_text_trans": `${props?.type == "recentStories" || props?.type == "trendingStories" ? "uppercase" : "none"}`,
          "--author_by_color": `${props?.type == "trendingStories" ? "#fff" : getColorsForMobile(props, key, "authorby")}`,
        }}
      >
        <span className={styles["author_by"]}> By</span>&nbsp;{displayNames}
      </span>
    );
  } else {
    return null;
  }
};
const renderCategory = (post) => {
  let category = "";
  if (post.categories) category = post.categories[0];
  if (post.Categories) category = post.Categories[0];
  if (category && !post.topStoriesChecked) {
    return (
      <span className={styles["category"]}>
        <a href={`/category/${category.toLowerCase()}`}>
          {category
            .replace(/-/g, " ")
            .replace("and", "&")
            .replace(/\\/g, "")
            .replace(/(tv)/, function (v) {
              return v.toUpperCase();
            })}
          &nbsp;<span className="bar__line">|</span>
        </a>
      </span>
    );
  } else {
    return null;
  }
};

const renderPromoted = (post, props, key) => {
  let promoted = "";
  if (post.promoted) {
    promoted = post.promoted;
  }
  if (post.Promoted) {
    promoted = post.Promoted;
  }
  if (promoted && !post.topStoriesChecked && promoted.toLowerCase() !== "open road media") {
    return (
      <span
        className={styles["promoted"]}
        style={{
          "--prompted_color": `${getColorsForMobile(props, key, "promoted")}`,
        }}
      >
        &nbsp;{`PROMOTED BY ${promoted}`}&nbsp;|
      </span>
    );
  } else {
    return null;
  }
};
const renderPost = (post, props, isMobile, isTablet, slug, key) => {
  let renderSubTitle = true,
    renderCategories = true,
    renderPromotedText = true,
    renderAuthors = true,
    subTitle = post.sub_title ? post.sub_title : post.Sub_Title,
    useLGImage = false;
  if (post.topStoriesChecked) useLGImage = true;
  if (props.isMobile && props?.type == "topStories" && !post.topStoriesChecked) {
    renderSubTitle = false;
  } else if (props?.type === "recentStories") {
    renderSubTitle = false;
  }
  if (props.isMobile && props?.type == "topStories") {
    renderCategories = false;
  }
  if (props.isMobile && props?.type == "topStories") {
    renderPromotedText = false;
  }
  if (props.isMobile && props?.type == "topStories") {
    renderAuthors = false;
  }
  if (
    (subTitle &&
      subTitle.length > 40 &&
      !post.topStoriesChecked &&
      props?.type !== "trendingStories") ||
    (props.isMobile && post.topStoriesChecked)
  ) {
    subTitle = `${shorten(subTitle, 40)}...`;
  }

  const featuredImageWidth = isTablet ? 736 : isMobile ? 396 : 1200;
  const featuredImageHeight = isTablet ? 310 : isMobile ? 167 : 506;
  return (
    <React.Fragment>
      <a href={slug}>
        {props?.type !== "recentStories" && (
          <div
            className={post.topStoriesChecked ? "topstory-image" : ""}
            style={{ width: "100%", margin: "auto" }}
          >
            <NextImage
              ImageUrl={formatImageUrlByDevice(
                post.featured_media ? post.featured_media.name : post.Featured_Media.Name,
                props.DeviceSize,
                props.ImageSize,
                useLGImage
              )}
              style={{ width: "100%", height: "auto" }}
              Alt_Text={
                post.featured_media
                  ? post.featured_media.alt_text
                    ? post.featured_media.alt_text
                    : post.featured_media.Alt_Text
                      ? post.featured_media.Alt_Text
                      : ""
                  : ""
              }
              width={featuredImageWidth}
              height={featuredImageHeight}
            />
          </div>
        )}
      </a>
      <div
        className={[
          styles["post__info"],
          styles[props?.type],
          post.topStoriesChecked && styles["checkedStory"],
          "post__info",
          props?.type,
          post.topStoriesChecked && "checkedStory",
        ].join(" ")}
        style={{
          "--post-title-color": `${props?.isMobile && key % 2 !== 0 ? "#fff" : "#000"}`,
        }}
      >
        <a href={slug}>
          <div className={[styles["post-title"], "post-title"].join(" ")}>
            <h2
              className="plain"
              dangerouslySetInnerHTML={{
                __html: post.Title ? post.Title : post.title,
              }}
            />
            {renderSubTitle && (
              <p
                className={[styles["sub-title"], "sub-title"].join(" ")}
                dangerouslySetInnerHTML={{
                  __html: subTitle,
                }}
              />
            )}
          </div>
        </a>
        {renderCategories && renderCategory(post, props, key)}
        {renderPromotedText && renderPromoted(post, props, key)}
        {renderAuthors && renderAuthor(post, props, key)}
        {props?.type == "trendingStories" && (
          <div className={styles["trendingstories__readnow__button"]}>
            <a href={slug}>
              <span className={styles["trendingstories__readnow__text"]}>READ NOW</span>
              &nbsp;
              <span>
                <i className={[styles["arrow"], "arrow", styles["right"], "right"].join(" ")}></i>
              </span>
            </a>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const getStories = (props, isMobile, isTablet, type) => {
  return props.posts.map((post, key) => {
    let slug =
      "/" +
      formatUrl(post.Slug ? post.Slug : post.slug, post.Redirect ? post.Redirect : post.redirect);
    if (type === "top-stories" && post.topStoriesChecked) {
      return (
        <div
          className={[styles["posthomepage__top__story"], "posthomepage__top__story"].join(" ")}
          key={key}
        >
          {renderPost(post, props, isMobile, isTablet, slug)}
        </div>
      );
    }

    if (type === "featured-stories" && !post.topStoriesChecked) {
      const clsName = `posthomepage__${props?.type == "topStories" ? "featuredArticle" : props?.type.replace("ies", "y")}`;
      return (
        <div
          className={[styles[clsName], clsName].join(" ")}
          key={key}
          style={{
            "--recentStoryBackColor": `${props.isMobile && key % 2 !== 0 ? "#152934" : "#f5f7fa"}`,
          }}
        >
          {renderPost(post, props, isMobile, isTablet, slug, key)}
        </div>
      );
    }
  });
};

const renderAds = (props, deals, retailerCookie, siteDealsURL) => {
  let ad2 = "";
  if (!props.isMobile) {
    ad2 = props.adNetwork == "SheKnows" ? <SheKnowsAd type={"medrec"} /> : <GoogleAdSense />;
  }
  return (
    <div className={[styles["ads"], styles["ads_diamensions"]].join(" ")}>
      <div className={styles["ad1"]}>
        <Deals deals={deals} retailerCookie={retailerCookie} siteDealsURL={siteDealsURL} />
      </div>
      <div className={styles["ad2"]}>{ad2}</div>
    </div>
  );
};

const HomePageStories = (props) => {
  const [deals, setDeals] = useState("");
  const {
    data: {
      SiteSettings: {
        site_header: { nav_items },
      },
    },
    retailerCookie,
    isMobile,
    isTablet,
  } = useAppContext();
  const [dealsURL] = nav_items.filter((el) => el.isTopDealUrl);
  const [siteDealsURL, setSiteDealsURL] = useState("");

  useEffect(() => {
    (async () => {
      let url = dealsURL?.url.replace("/", "");
      setSiteDealsURL(url);
      if (props?.currentSiteID && url) {
        const postData = await apiRequestWithRetry(`post/${props?.currentSiteID}?slug=${url}`);
        let dealsData = postData?.post?.components.filter(
          (el) =>
            el &&
            el?.type === "book-listicle-info" &&
            el?.props?.affiliate?.props?.urlType === "Internal Link"
        );
        if (dealsData && dealsData.length > 0) {
          dealsData.length = 3;
          setDeals(dealsData);
        }
      }
    })();
  }, [dealsURL?.url]);

  const homepageSectionClass = `posthomepage__${props?.type == "topStories" ? "featuredArticles" : props?.type}__section`;
  const homepageClass = `posthomepage__${props?.type == "topStories" ? "featuredArticles" : props?.type}`;
  return (
    <div
      className={styles["posthomepage__stories"]}
      style={{
        "--homepageStoryMargin": `${props?.type === "trendingStories" ? 0 : "1rem"}`,
      }}
    >
      {props?.type == "topStories" && (
        <div className={styles["posthomepage__top__stories"]}>
          {getStories(props, isMobile, isTablet, "top-stories")}
        </div>
      )}
      <div className={styles[homepageSectionClass]}>
        <div className={styles[homepageClass]}>
          {getStories(props, isMobile, isTablet, "featured-stories")}
          {props?.type === "topStories" && renderAds(props, deals, retailerCookie, siteDealsURL)}
        </div>
      </div>
    </div>
  );
};
export default HomePageStories;
